module.exports = __webpack_public_path__ + "img/interactive-kiosks-portrait-landscape.a5c4b6af.png";